import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from "../config/config";
import { BusinessSettingsContext } from "../context/BusinessSettingsContext";

const Register = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        remember: false
    });

    const { settings } = useContext(BusinessSettingsContext);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        try {
            const response = await fetch(`${BASE_URL}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.errors ? JSON.stringify(data.errors) : data.message);
            }

            setSuccess('User registered successfully!');
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <div className="row row--grid">
                    <div className="col-12">
                        <div className="sign">
                            <div className="sign__content">
                                <form onSubmit={handleSubmit} className="sign__form">
                                    <a href="/" className="sign__logo">
                                        <img src={ settings.website_logo || "Website Name" } alt=''/>
                                    </a>

                                    {error && <div style={{ color: 'red' }}>{error}</div>}
                                    {success && <div style={{ color: 'green' }}>{success}</div>}

                                    <div className="sign__group">
                                        <input 
                                            type="text" 
                                            className="sign__input" 
                                            placeholder="Name" 
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="sign__group">
                                        <input 
                                            type="email" 
                                            className="sign__input" 
                                            placeholder="Email" 
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="sign__group">
                                        <input 
                                            type="password" 
                                            className="sign__input" 
                                            placeholder="Password" 
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="sign__group sign__group--checkbox">
                                        <input 
                                            id="remember" 
                                            name="remember" 
                                            type="checkbox" 
                                            checked={formData.remember}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="remember">I agree to the <Link to="/privacy-policy">Privacy Policy</Link></label>
                                    </div>
                                    
                                    <button className="sign__btn" type="submit">Sign up</button>

                                    <span className="sign__text">Already have an account? <Link to="/signin">Sign In!</Link></span>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Register;
